
<nav class="sidebar" [ngClass]="{'open': isSidebarOpen}"
     (mouseover)="toggleSidebarHover(true)"
     (mouseout)="toggleSidebarHover(false)">
  <div class="logo">
    <a [href]="homeDir">
      <img *ngIf="!isSidebarOpen" src="./assets/logos/logo-short-128.png" alt="Cinego Ententes" />
      <img *ngIf="isSidebarOpen"  src="./assets/logos/logo-long-256.png" alt="Cinego Ententes" />
    </a>
  </div>
  <ul class="nav-items">
    <li>
      <a (click)="togglePlanningRegion()" [ngClass]="{'rotate-down': isPlanningRegionOpen, 'rotate-left': !isPlanningRegionOpen}">
        <i class="bi-calendar icon"></i>
        <span class="nav-link">Planning Region</span>
        <i *ngIf="isSidebarOpen" class="bi-chevron-left arrow"></i>
      </a>

      <ul [ngClass]="{'sub-nav-items': true, 'open': isPlanningRegionOpen && isSidebarOpen}">
        <li *ngFor="let item of navItems">
          <a  [ngClass]="{'active': isActive(item.path)}"  [href]="item.path" (click)="changeRegion(item.path)">
            <span class="nav-text">{{ item.label }}</span>
          </a>
        </li>
      </ul>

    </li>
  </ul>
</nav>

